import React, { useState, useRef, useEffect } from 'react'
import { Grid, Row, Panel, Table } from 'rsuite'

export default function ProgessProductView(props) {
  const { Column, HeaderCell, Cell } = Table

  const { schema } = props
  const containerRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [containerRef, windowWidth])

  return (
    <div ref={containerRef}>
      <Row>
        <Panel bodyFill>
          <Grid fluid>
            <Table
              isTree
              defaultExpandAllRows
              rowKey="id"
              cellBordered
              // height={400}
              autoHeight
              wordWrap
              data={schema?.values || []}
            >
              <Column resizable width={containerWidth > 500 ? (containerWidth/2)-50: 250}>
                <HeaderCell>{schema.columnText1}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return rowData.labelName || rowData.expectedProduct
                  }}
                </Cell>
              </Column>

              <Column width={100} align="center" verticalAlign="middle">
                <HeaderCell>{schema.columnText2}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (typeof rowData.productType !== 'undefined') {
                      return (
                        <>
                          {schema.productTypeOptions.map((item) => {
                            if (item.value == rowData.productType) {
                              return item.label
                            }
                          })}
                        </>
                      )
                    }
                  }}
                </Cell>
              </Column>

              <Column resizable width={containerWidth > 500 ? (containerWidth/2)-50: 250}>
                <HeaderCell>{schema.columnText3}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return `${
                      rowData.notEffective
                        ? 'ไม่เกิดผลในครั้งนี้'
                        : `${rowData.result || ''} ${rowData.unit || ''}`
                    }`
                  }}
                </Cell>
              </Column>
            </Table>
          </Grid>
        </Panel>
      </Row>
    </div>
  )
}
